var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowBottom = function SvgArrowBottom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.7341 6.68345L9.88566 1.05198C9.96035 0.945682 9.99977 0.825133 10 0.702385C10.0002 0.579637 9.96125 0.458989 9.88696 0.352502C9.81267 0.246014 9.70567 0.157416 9.57666 0.0955621C9.44765 0.0337086 9.30114 0.0007664 9.15178 2.80684e-05L0.857193 2.77058e-05C0.706102 -0.00108385 0.557361 0.0307933 0.426172 0.0924012C0.294984 0.154009 0.186051 0.243138 0.110509 0.350679C0.0380325 0.457953 -2.52928e-08 0.578631 -3.06562e-08 0.701331C-3.60196e-08 0.824032 0.0380325 0.94471 0.110509 1.05198L4.26207 6.66241C4.33813 6.76547 4.44523 6.85067 4.57303 6.9098C4.70083 6.96894 4.84502 7 4.99169 7C5.13835 7 5.28254 6.96894 5.41034 6.9098C5.53814 6.85067 5.64524 6.76547 5.7213 6.66241L5.7341 6.68345Z",
    fill: "#595959"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowBottom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow-bottom.ff67185bc87a144759b96523d9fedcce.svg";